// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3Rs5D","label":"Labeled_label__A3Vhb","divider":"Labeled_divider__1fCMn"};